import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  getAllCars,
  getCarsByDate,
  getCurrentCars,
  getCarsForHour,
  getCalendarByMonth,
  getNewCarsRange,
  getPercentForHour,
  changeCarStatus,
  getPeriodCars,
  getStatistics,
  updateRecordData,
  getPaymentStatistic,
} from "./operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const carsSlice = createSlice({
  name: "cars",
  initialState: {
    ...initialState.cars,
  },
  reducers: {
    changeActualDate: (state, action) => {
      state.date = action.payload;
      // state.loadPercent = action.payload.percent;
    },
    changeActualPercent: (state, action) => {
      state.loadPercent = action.payload;
      // state.loadPercent = action.payload.percent;
    },
    setQueryMonth: (state, action) => {
      state.queryMonth = action.payload;
    },
    changeSelectedMonth: (state, action) => {
      state.selectedMonth = action.payload;
    },
    setWorkHoursForCurrentDay(state, action) {
      if (
        !state.workHoursForCurrentDay ||
        Object.keys(state.workHoursForCurrentDay).length === 0
      ) {
        state.workHoursForCurrentDay = action.payload || {};
        // зберігаємо поточну дату
        state.lastSetDate = new Date().toISOString().slice(0, 10); // формат YYYY-MM-DD
      }
    },

    resetWorkHoursForCurrentDay(state) {
      state.workHoursForCurrentDay = {};
      state.lastSetDate = null;
    },
    resetPlanner(state) {
      state.records = [];
      state.error = null;
      state.booking = [];
    },
    clearAllCars(state) {
      state.records = [];
    },
  },
  extraReducers: builder =>
    builder
      // Get all cars in work for monitoring page +
      .addCase(getAllCars.pending, handlePending)
      .addCase(getAllCars.fulfilled, (state, action) => {
        state.isLoading = false;
        // всі машини
        state.records = action.payload.records || [];
        // записи (booked)
        state.booking = action.payload.client_records || [];
      })
      .addCase(getAllCars.rejected, handleRejected)

      // Update record data +
      .addCase(updateRecordData.pending, state => {
        state.error = null;
      })
      .addCase(updateRecordData.fulfilled, (state, action) => {
        // console.log(action.payload.id);

        const recordToEditIndex = state.records.findIndex(
          record => record.id === action.payload.id
        );
        state.records[recordToEditIndex] = action.payload;
      })
      .addCase(updateRecordData.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Get current cars +
      .addCase(getCurrentCars.pending, (state, action) => {
        state.isCurrentCarsLoading = true;
        state.error = null;
      })
      .addCase(getCurrentCars.fulfilled, (state, action) => {
        state.isCurrentCarsLoading = false;
        state.current = action.payload;
      })
      .addCase(getCurrentCars.rejected, (state, action) => {
        state.isCurrentCarsLoading = false;
        state.error = action.payload;
        if (action.payload?.status === 404) {
          state.current = [];
        }
      })
      .addCase(getCarsByDate.pending, state => {
        state.isLoadingCarsByDay = true;
        state.error = null;
      })
      .addCase(getCarsByDate.fulfilled, (state, action) => {
        state.isLoadingCarsByDay = false;
        //   state.date = action.payload.date;
        state.day = action.payload.cars;
      })
      .addCase(getCarsByDate.rejected, (state, action) => {
        state.isLoadingCarsByDay = false;
        state.error = action.payload;
        if (action.payload?.status === 404) {
          state.day = [];
        }
      })
      .addCase(getCarsForHour.pending, handlePending)
      .addCase(getCarsForHour.fulfilled, (state, action) => {
        state.isLoading = false;
        //   state.date = action.payload.date;
        state.forHours = action.payload.hourly_car_count;
        state.workHours = action.payload.working_hours;
      })
      .addCase(getCarsForHour.rejected, handleRejected)
      .addCase(getPercentForHour.pending, handlePending)
      .addCase(getPercentForHour.fulfilled, (state, action) => {
        state.isLoading = false;
        state.loadPercent = action.payload;
      })
      .addCase(getPercentForHour.rejected, handleRejected)
      .addCase(getCalendarByMonth.pending, state => {
        state.isLoadingForCalendar = true;
        state.error = null;
      })
      .addCase(getCalendarByMonth.fulfilled, (state, action) => {
        state.isLoadingForCalendar = false;
        state.monthlyLoad = action.payload;
      })
      .addCase(getCalendarByMonth.rejected, (state, action) => {
        state.isLoadingForCalendar = false;
        state.error = action.payload;
      })

      // Get new cars in range of two particular dates +
      .addCase(getNewCarsRange.pending, handlePending)
      .addCase(getNewCarsRange.fulfilled, (state, action) => {
        state.isLoading = false;
        state.newCars = action.payload;
      })
      .addCase(getNewCarsRange.rejected, handleRejected)

      // Get payments statistics for Stats Panel +
      .addCase(getPaymentStatistic.pending, state => {
        state.isPaymentStatisticLoading = true;
        state.error = null;
      })
      .addCase(getPaymentStatistic.fulfilled, (state, action) => {
        state.isPaymentStatisticLoading = false;
        state.paymentStatistic = action.payload;
      })
      .addCase(getPaymentStatistic.rejected, (state, action) => {
        state.isPaymentStatisticLoading = false;
        state.error = action.payload;
      })

      .addCase(changeCarStatus.pending, handlePending)
      .addCase(changeCarStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { car_id, newStatus } = action.payload;
        const carIndex = state.current.findIndex(car => car.car_id === car_id);
        if (carIndex !== -1) {
          state.current[carIndex].status = newStatus;
        }
      })
      .addCase(changeCarStatus.rejected, handleRejected)
      .addCase(getPeriodCars.pending, handlePending)
      .addCase(getPeriodCars.fulfilled, (state, action) => {
        state.isLoading = false;
        state.periodCars = action.payload.cars;
      })
      .addCase(getPeriodCars.rejected, handleRejected)

      // Get statistics for cars per month and day +
      .addCase(getStatistics.pending, handlePending)
      .addCase(getStatistics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.statistics = action.payload.statistics;
      })
      .addCase(getStatistics.rejected, handleRejected),
});

export const {
  changeActualDate,
  changeSelectedMonth,
  changeActualPercent,
  setQueryMonth,
  setWorkHoursForCurrentDay,
  resetWorkHoursForCurrentDay,
  resetPlanner,
  clearAllCars,
} = carsSlice.actions;

export default carsSlice.reducer;
